import { KeyOf } from '~/types';
import { colors } from './colors';

export const backgroundColorLight = {
  base: colors.white,

  disabled: colors.blackAlpha10,
  disabled_border: colors.blackAlpha10,

  elevated: colors.neutral10,

  elevated_divider: colors.whiteAlpha20,
  elevated_border: colors.neutral200,

  onelevated: colors.neutral30,
  onelevated_divider: colors.blackAlpha20,
  onelevated_tint: colors.whiteAlpha60,
  onelevated_tint_reverse: colors.blackAlpha60,
  onelevated_border: colors.blackAlpha20,

  modal_bg: colors.blackAlpha10,
  modal_border: colors.blackAlpha10,

  divider: colors.blackAlpha10,

  bg_light_1: '#FFFFFF',
  bg_light_2_alpha: colors.whiteAlpha95,
  bg_light_3_alpha: colors.whiteAlpha90,
  bg_light_4: '#AFAFB6',
  bg_light_5_alpha: colors.whiteAlpha20,

  bg_dark_1: '#09090A',
  bg_dark_2: '#16191C',
  bg_dark_3: '#303036',
  bg_dark_4_alpha: colors.blackAlpha40,
  bg_dark_5_alpha: colors.blackAlpha30,
} as const;

export const backgroundColorDark: BackgroundColor = {
  base: '#09090a',

  disabled: colors.whiteAlpha10,
  disabled_border: colors.whiteAlpha20,

  elevated: colors.neutral800,
  elevated_divider: colors.neutral600,
  elevated_border: colors.neutral200,

  onelevated: colors.neutral700,
  onelevated_divider: colors.whiteAlpha20,
  onelevated_tint: colors.blackAlpha60,
  onelevated_tint_reverse: colors.whiteAlpha60,
  onelevated_border: colors.whiteAlpha20,

  modal_bg: colors.blackAlpha80,
  modal_border: colors.whiteAlpha20,

  divider: colors.whiteAlpha20,

  bg_light_1: '#FFFFFF',
  bg_light_2_alpha: colors.whiteAlpha95,
  bg_light_3_alpha: colors.whiteAlpha90,
  bg_light_4: '#AFAFB6',
  bg_light_5_alpha: colors.whiteAlpha20,

  bg_dark_1: '#09090A',
  bg_dark_2: '#16191C',
  bg_dark_3: '#303036',
  bg_dark_4_alpha: colors.blackAlpha40,
  bg_dark_5_alpha: colors.blackAlpha30,
};

export type BackgroundColor = typeof backgroundColorLight;
export type BackgroundColorKeys = KeyOf<typeof backgroundColorLight>;
